import { getErrorMessage } from "@/core/services";
import { useAsyncList } from "@/ds";
import { listarCurvas } from "@/modules/financeiro-configuracoes";
import type { CurvaItem, ListarCurvasParams } from "@/modules/financeiro-configuracoes";
import { CURVAS_ERROR_MESSAGE, CURVAS_FORBIDDEN_MESSAGE } from "../curvas.constants";

export function useCurvasDados(filtro: ListarCurvasParams) {
  const lista = useAsyncList<ListarCurvasParams, CurvaItem>({
    fetcher: async (params, signal) => {
      const items = await listarCurvas(params, { signal });
      return { items, total: items.length };
    },
    params: filtro,
    forbiddenMessage: CURVAS_FORBIDDEN_MESSAGE,
    errorMessage: CURVAS_ERROR_MESSAGE,
    resolveErrorMessage: getErrorMessage,
  });

  return {
    curvas: lista.items,
    carregando: lista.isLoading,
    semPermissao: lista.status === "forbidden",
    erro: lista.status === "error" ? lista.errorMessage : null,
    recarregar: lista.reload,
  };
}
